import { IWidgetData, SelfPosition } from "./index";

export interface IMeshData {
    readonly type: "Mesh";
    id?: string;
    meshAlignment?: SelfPosition;
    rows?: IMeshRowData[]; // filled only for cascade rendering, otherwise is undefined
}

export interface IMeshRowData {
    readonly type: "MeshRow";
    id?: string;
    isEmpty: boolean;
    columns?: IMeshColumnData[]; // filled only for cascade rendering, otherwise is undefined
}

export interface IMeshColumnData {
    readonly type: "MeshColumn";
    id?: string;
    size: number;
    isEmpty: boolean;
    widgets?: IWidgetData[]; // filled only for cascade rendering, otherwise is undefined
}

export abstract class MeshData {

    public static get defaultData(): IMeshData {
        return {
            type: "Mesh",
            meshAlignment: "top",
            rows: []
        };
    }

    public static get defaultRowData(): IMeshRowData {
        return {
            type: "MeshRow",
            isEmpty: true
        };
    }

    public static get defaultColumnData(): IMeshColumnData {
        return {
            type: "MeshColumn",
            size: 1,
            isEmpty: true
        };
    }

}